import Colors from "../../core/Colors";
import { ComponentF } from "../ui";
export const Bar: ComponentF<{
  current: number;
  fillColor: string;
  max: number;
}> = (C, props = { current: 0, max: 0, fillColor: "#FFFFFF" }) => {
  const pct = props.current / props.max;
  let l = 0;
  const text = `${props.current} / ${props.max}`;
  const tLen = text.length;
  C.display.drawText(C.bounds.x, C.bounds.y, `%c{${Colors.B_GREY_5}}${text}`);

  for (; l / C.bounds.w < pct; l++) {
    C.display.drawOver(
      l + C.bounds.x,
      C.bounds.y,
      tLen <= l ? " " : null,
      null,
      props.fillColor
    );
  }
  for (; l < C.bounds.w; l++) {
    C.display.drawOver(
      l + C.bounds.x,
      C.bounds.y,
      tLen <= l ? " " : null,
      null,
      Colors.B_GREY_2
    );
  }
};
